module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "chapter26"
    }
  }, [_c('h1', [_c('a', {
    attrs: {
      "id": "page_44"
    }
  }), _c('a', {
    attrs: {
      "href": "#/003toc#ch26"
    }
  }, [_vm._v("Mom’s Chicken Noodle Goodness")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Mom’s comfort food, this noodle soup is filled with veggies and chunks of chicken to make even the worst day seem bearable. Pair this with Cheddar cheese biscuits or scones.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("2 tablespoons olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("1 cup finely chopped onion")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("2 cups finely chopped celery")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("2 cups finely chopped carrot")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("2 small zucchini, finely chopped")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("1 teaspoon dried thyme")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("12 cups chicken broth")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("4 cups bite-size pieces cooked chicken")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Two 10-ounce packages fresh baby spinach")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Salt and freshly ground black pepper")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("8 ounces medium-width egg noodles, cooked al dente")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("heat the oil in a large skillet over medium-high heat. Add the onion, celery, carrot, zucchini, and thyme and sauté until the vegetables are softened, about 7 minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("transfer the contents of the skillet to the insert of a 5- to 7-quart slow cooker. Stir in the broth, chicken, and spinach.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("cover and cook on high for 4 hours or on low for 8 hours.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("season with salt and pepper. Add the noodles to the soup, stir, cover, and let stand for 5 minutes before serving.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("serves 8–10")])]), _vm._v(" "), _c('p', {
    staticClass: "breakhere"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ce605ede","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/032-chapter26.vue
// module id = 150
// module chunks = 0